"use client";

import { c as _c } from "react/compiler-runtime";
import { CalendarDotsIcon, ChartBarIcon, ClipboardTextIcon, DatabaseIcon, FileTextIcon, GearIcon, KeyIcon, NotificationIcon, PlugsIcon, ShieldCheckIcon, TreeStructureIcon, UsersIcon } from "@phosphor-icons/react";
import Image from "next/image";
import ArpanoLogo from "../ui/arpano-logo";
import { DesktopOnly } from "../ui/desktop-only";
import { OrbitingCircles } from "../ui/orbiting-circles";
function AdminIcon(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="size-full rounded-full border border-border bg-background/80 backdrop-blur flex items-center justify-center shadow-sm"><div className="text-foreground">{children}</div></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default function AdministrationSection() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["Documentos", "Usuarios", "Contabilidad", "Auditor\xEDa", "Tareas", "Anal\xEDtica", "Recursos Humanos", "Configuraci\xF3n"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const features = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="/admin-section.webp" alt={"Administraci\xF3n empresarial con IA"} fill={true} className="object-cover" />;
    t2 = <div className="absolute inset-0 bg-background/20" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AdminIcon><FileTextIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AdminIcon><UsersIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AdminIcon><ChartBarIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <AdminIcon><CalendarDotsIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AdminIcon><GearIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <AdminIcon><ShieldCheckIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <AdminIcon><NotificationIcon className="size-5" weight="duotone" /></AdminIcon>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <OrbitingCircles radius={210} duration={34} iconSize={40} className="motion-reduce:animate-none" path={true}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}<AdminIcon><TreeStructureIcon className="size-5" weight="duotone" /></AdminIcon></OrbitingCircles>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <AdminIcon><DatabaseIcon className="size-4" weight="duotone" /></AdminIcon>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <AdminIcon><KeyIcon className="size-4" weight="duotone" /></AdminIcon>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <AdminIcon><ClipboardTextIcon className="size-4" weight="duotone" /></AdminIcon>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <OrbitingCircles radius={130} duration={22} reverse={true} iconSize={34} className="motion-reduce:animate-none" path={true}>{t11}{t12}{t13}<AdminIcon><PlugsIcon className="size-4" weight="duotone" /></AdminIcon></OrbitingCircles>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DesktopOnly><div className="absolute inset-0 flex items-center justify-center pointer-events-none"><div className="relative size-[520px]">{t10}{t14}<div className="absolute inset-0 flex items-center justify-center"><div className="rounded-full border border-border bg-background/90 backdrop-blur px-10 py-5 shadow-xl text-center"><p className="text-xs font-mono text-muted-foreground">ADM-4RP</p><ArpanoLogo /><p className="font-sans font-bold text-foreground">ADMIN CORE</p></div></div></div></div></DesktopOnly>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  let t17;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex items-center justify-start gap-2"><h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-6">ADMINISTRACIÓN</h2><p className="text-xs font-mono text-muted-foreground self-start">ADM-4RP</p></div>;
    t17 = <p className="text-sm font-mono text-muted leading-relaxed max-w-xl">Gestión inteligente de recursos empresariales con IA predictiva en tiempo real. Automatización de procesos, asignación de personal y auditoría operativa con visibilidad end-to-end.</p>;
    $[16] = t16;
    $[17] = t17;
  } else {
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <section className="relative w-full lg:min-h-screen overflow-hidden">{t1}{t2}<div className="relative z-10 px-6 py-16 pb-20 sm:px-12 sm:py-16 sm:pb-20 lg:p-20 lg:min-h-screen flex items-center">{t15}<div className="relative max-w-xl lg:max-w-lg lg:absolute lg:left-20 lg:bottom-20"><div className="bg-background border border-border p-6 sm:p-8 lg:p-10 shadow-xl">{t16}{t17}<div className="mt-6 grid grid-cols-2 gap-2 text-xs font-mono text-muted-foreground">{features.map(_temp)}</div></div></div></div></section>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  return t18;
}
function _temp(label) {
  return <div key={label} className="border border-border bg-muted/20 px-3 py-2">{label}</div>;
}